import { useEffect, useState } from "react";

import {
  clearLegacyDisplayTimezone,
  getDeviceTimezone,
} from "@/modules/dial-blocks/lib/display-timezone";

/**
 * The zone dial-block times are shown in: the browser's own, whatever the
 * retired "Show times in" picker once saved (that choice is cleared). Read
 * at render, as the picker's "Local" was: My Week and the bell render on the
 * client only (behind the auth layout), so there is no server first frame.
 */
export const useLocalTimezone = () => {
  const [zone] = useState(getDeviceTimezone);

  useEffect(() => {
    clearLegacyDisplayTimezone();
  }, []);

  return { zone };
};
